import { TinyMCEHelper } from "../../../Helpers/TinyMCEHelper";


export class AddOrUpdateDocumentationTopicManager {

    constructor(private containerElement: JQuery) { }

    public initialize() {
        this.bindElements();
        this.bindEvents();
    }

    private bindElements() {
        var self = this;
    }

    private bindEvents() {
        var self = this;

        TinyMCEHelper.remove('#tinymce-editor');
        TinyMCEHelper.initialize('#tinymce-editor');


        self.containerElement.find('form').off('submit').on("submit", () => {
            TinyMCEHelper.triggerSave();
        });
    }
}